import React, { useState, useEffect, useRef } from 'react';
import {
  Menu, X, Play, CheckCircle, Users, Building, CreditCard, FileText, Shield, Zap, Wheat,
  ChevronRight, Globe, Factory, Heart, ShoppingCart, TrendingUp, ArrowRightStar, Star, Truck, ArrowRight
} from 'lucide-react';
import Header from "./header";
import Footer from "./footer";
const EngagementModel = () => {
  const [activeIndustry, setActiveIndustry] = useState('fintech');
  const videoRef = useRef(null);


  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // const toggleMenu = () => {
  //   setIsMenuOpen(!isMenuOpen);
  // };

  const industries = {
    fintech: {
      title: "Banking & Fintech",
      icon: CreditCard,
      description: "Digital payment solutions, lending platforms, and financial services",
      majorPlayers: ["PayPal", "Stripe", "Square", "Razorpay", "Paytm", "PhonePe"],
      solutions: [
        { name: "Secure & compliant digital payments", desc: "Ensuring safe and regulated digital transactions" },
        { name: "AI-powered fraud prevention", desc: "Advanced AI systems to detect and prevent fraud" },
        { name: "Seamless UPI, card & wallet integration", desc: "Unified payment solutions with multiple modes" },
        { name: "Recon with AI", desc: "Automated reconciliation with AI-driven accuracy" },
        { name: "Digital KYC", desc: "Streamlined customer onboarding with digital KYC" }
      ],
      gradient: "from-green-500 to-emerald-500",
      bgGradient: "from-green-50 to-emerald-50"
    },
    banking: {
      title: "Retail & E-commerce",
      icon: ShoppingCart,
      description: "E-commerce platforms, inventory management, and customer analytics",
      majorPlayers: ["JPMorgan Chase", "Bank of America", "HDFC Bank", "ICICI Bank", "Wells Fargo"],
      solutions: [
        { name: "Fast & frictionless checkout", desc: "Smooth and secure checkout process" },
        { name: "Easy refunds & settlements", desc: "Simplified refunds and settlement process" },
        { name: "Scalable for festive & peak traffic", desc: "Infrastructure ready for high transaction volumes" },
        { name: "Manage market place aggregator", desc: "Integrated tools for marketplace management" }
      ],
      gradient: "from-blue-500 to-cyan-500",
      bgGradient: "from-blue-50 to-cyan-50"
    },
    retail: {
      title: "Logistics",
      icon: Truck,
      description: "E-commerce platforms, inventory management, and customer analytics",
      majorPlayers: ["Amazon", "Walmart", "Alibaba", "Shopify", "Target", "Flipkart"],
      solutions: [
        { name: "Hassle-free digital collections for deliveries", desc: "Seamless payment solutions for logistics" },
        { name: "Automated billing, invoicing & vendor payouts", desc: "Smart automation for financial operations" },
        { name: "NETC FASTag solutions", desc: "Toll payments & fleet management with FASTag" },
        { name: "Real-time payment tracking & reconciliation", desc: "Instant visibility into financial operations" },
        { name: "Scalable systems for large logistics networks", desc: "Enterprise-level infrastructure for logistics" }
      ],
      gradient: "from-purple-500 to-indigo-500",
      bgGradient: "from-purple-50 to-indigo-50"
    }
  };


  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };


  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      {/* Header */}
      <Header />
      {/* Hero Section - Dark Theme */}

      {/* <section className="bg-gradient-to-br from-blue-50 via-indigo-50 to-cyan-50 py-20 relative overflow-hidden">
        <div className="absolute top-10 right-10 w-20 h-20 bg-blue-200 rounded-full opacity-50 animate-pulse"></div>
        <div className="absolute bottom-20 left-10 w-16 h-16 bg-indigo-200 rounded-full opacity-60 animate-bounce"></div>
        <div className="absolute top-1/2 right-1/4 w-12 h-12 bg-cyan-200 rounded-full opacity-40 animate-pulse"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>

              <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                Technology Infrastructure<br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                  That Elevates Customer Experience
                </span>
              </h1>

              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                We provide robust, scalable, and reliable technology infrastructure designed to empower businesses, deliver exceptional customer experiences, and accelerate growth with seamless integration and high-performance processing.
              </p>


            </div>

            <div className="relative">
              <div className="bg-white rounded-3xl shadow-2xl p-8 transform hover:scale-105 transition-transform duration-300">
                <div className="mb-6">
                  <img
                    src="/final.png"
                    alt="Fintech Engagement"
                    className="w-full h-64 rounded-2xl object-cover"
                  />
                </div>
              </div>
            </div>

          </div>
        </div>
      </section> */}


      {/* Hero Section */}
      {/* Industries We Serve Section */}
      <section id="industries" className="py-5 bg-gray-50">
        <div className="container mx-auto px-4 py-5">
          <div className="text-center mb-2">
            {/* <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 animate-fade-in-up">
              Industries <span className="text-cyan-500">We Serve</span>
            </h2> */}
            {/* <p className="text-gray-600 text-lg animate-fade-in-up animation-delay-200">
              Empowering businesses across diverse sectors with cutting-edge technology solutions
            </p> */}

            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 animate-fade-in-up mb-10">
              <span className="inline-block animate-pulse bg-gradient-to-r from-blue-600 via-purple-600 to-cyan-600 bg-clip-text text-transparent">
                Industries
              </span>{" "}
              <span className="inline-block animate-bounce-slow">

                {/* Merchant Onboarding Solution? */}
              </span>
            </h2>
          </div>

          {/* Industry Tabs */}
          <div className="w-full overflow-x-auto px-4 mb-6 sm:mb-8 md:mb-12">
            <div className="flex gap-2 sm:gap-3 flex-nowrap min-w-max sm:justify-center">
              {Object.entries(industries).map(([key, industry]) => (
                <button
                  key={key}
                  onClick={() => setActiveIndustry(key)}
                  className={`flex items-center gap-2 px-4 sm:px-6 py-2 sm:py-3 rounded-full whitespace-nowrap text-sm sm:text-base transition-all duration-300 ${activeIndustry === key
                    ? `bg-gradient-to-r ${industry.gradient} text-white shadow-md transform scale-105`
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                    }`}
                >
                  <industry.icon size={16} className="sm:size-20" />
                  <span className="font-medium">{industry.title}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Active Industry Content */}
          <div className={`bg-gradient-to-br ${industries[activeIndustry].bgGradient} rounded-2xl sm:rounded-3xl px-4 py-6 sm:px-6 sm:py-8 md:p-12 relative overflow-hidden`}>
            {/* Decorative Blurs */}
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute top-6 right-6 w-32 h-32 sm:w-48 sm:h-48 bg-white rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
              <div className="absolute bottom-6 left-6 w-40 h-40 sm:w-60 sm:h-60 bg-white rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-2000"></div>
            </div>

            <div className="relative z-10">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-10 items-start">

                {/* Left Side - Industry Info */}
                <div className="animate-fade-in-left">
                  <div className={`mt-4 sm:mt-0 bg-gradient-to-r ${industries[activeIndustry].gradient} text-white px-5 py-2 sm:px-2 sm:py-3 rounded-lg hover:shadow-lg transition-all duration-300 transform hover:scale-105 font-semibold text-sm sm:text-base w-70`}>
                    Explore {industries[activeIndustry].title} Solutions
                  </div>
                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mt-2">

                    <div>
                      <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900">
                        {industries[activeIndustry].title}
                      </h3>
                      <p className="text-sm sm:text-base text-gray-600">
                        {industries[activeIndustry].description}
                      </p>
                    </div>
                  </div>




                </div>

                {/* Right Side - Solutions */}
                <div className="animate-fade-in-right">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {industries[activeIndustry].solutions.map((solution, index) => (
                      <div
                        key={index}
                        className="bg-white rounded-xl p-4 sm:p-6 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                      >
                        <h5 className="font-semibold text-sm sm:text-base text-gray-900 mb-1">
                          {solution.name}
                        </h5>
                        <p className="text-xs sm:text-sm text-gray-600">{solution.desc}</p>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </section>

      {/* CTA Section */}
      <section className="py-8 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 relative overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
          <div className="absolute top-40 right-20 w-24 h-24 bg-white/5 rounded-lg animate-bounce transform rotate-45" style={{ animationDelay: '1s' }}></div>
          <div className="absolute bottom-20 left-20 w-16 h-16 bg-white/10 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
          <div className="absolute bottom-40 right-10 w-20 h-20 bg-white/5 rounded-lg animate-bounce transform -rotate-12" style={{ animationDelay: '0.5s' }}></div>

          <div className="absolute top-1/4 left-1/4 animate-float">
            <Zap className="w-8 h-8 text-white/20" />
          </div>
          <div className="absolute top-1/3 right-1/3 animate-float" style={{ animationDelay: '1.5s' }}>
            <Shield className="w-6 h-6 text-white/20" />
          </div>
          <div className="absolute bottom-1/3 left-1/3 animate-float" style={{ animationDelay: '3s' }}>
            <TrendingUp className="w-7 h-7 text-white/20" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          {/* Main Content */}
          <div className="space-y-4 animate-fadeInUp">
            <h2 className="text-2xl sm:text-4xl lg:text-4xl font-bold text-white leading-tight animate-slideInLeft">
              Empowering diverse industries with innovative solutions.
            </h2>
            {/* <p className="text-1xl sm:text-1xl lg:text-1xl text-blue-100">Get started with our comprehensive suite of business solutions today</p> */}
          </div>

          {/* CTA Button - Smaller and More Compact */}
          <div className="mt-6 animate-fadeInUp" style={{ animationDelay: '1.2s' }}>
            <button
              className="group relative inline-flex items-center gap-3 bg-gradient-to-r from-white to-blue-50 text-blue-700 px-8 py-3 rounded-xl font-semibold text-lg hover:from-yellow-300 hover:to-orange-300 hover:text-gray-900 transform hover:scale-105 transition-all duration-500 shadow-xl hover:shadow-yellow-300/50"
              onClick={() => {
                window.location.href = '/contact';
              }}
            >
              {/* <Play className="w-5 h-5 group-hover:animate-bounce" /> */}
              <span>Get Started</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />

              {/* Button Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </button>
          </div>
        </div>

        <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          33% { transform: translateY(-10px) rotate(5deg); }
          66% { transform: translateY(5px) rotate(-5deg); }
        }
        
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slideInUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
        
        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInLeft {
          animation: slideInLeft 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInRight {
          animation: slideInRight 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInUp {
          animation: slideInUp 0.8s ease-out forwards;
          opacity: 0;
        }
      `}</style>
      </section>

      {/* Platform Section */}
      {/* Products Section */}


      <Footer />
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        
        @keyframes fade-in-up {
          0% { opacity: 0; transform: translateY(30px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes fade-in-left {
          0% { opacity: 0; transform: translateX(-30px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes fade-in-right {
          0% { opacity: 0; transform: translateX(30px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slide-in-left {
          0% { opacity: 0; transform: translateX(-20px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slide-in-right {
          0% { opacity: 0; transform: translateX(20px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes bounce-slow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-5px); }
        }
        
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
        }
        
        .animate-fade-in-left {
          animation: fade-in-left 0.8s ease-out forwards;
        }
        
        .animate-fade-in-right {
          animation: fade-in-right 0.8s ease-out forwards;
        }
        
        .animate-slide-in-left {
          animation: slide-in-left 0.6s ease-out forwards;
        }
        
        .animate-slide-in-right {
          animation: slide-in-right 0.6s ease-out forwards;
        }
        
        .animate-bounce-slow {
          animation: bounce-slow 2s ease-in-out infinite;
        }
        
        .animation-delay-200 {
          animation-delay: 200ms;
        }
        
        .animation-delay-400 {
          animation-delay: 400ms;
        }
        
        .animation-delay-600 {
          animation-delay: 600ms;
        }
        
        .animation-delay-800 {
          animation-delay: 800ms;
        }
        
        .animation-delay-1000 {
          animation-delay: 1000ms;
        }
        
        .animation-delay-2000 {
          animation-delay: 2000ms;
        }
        
        .animation-delay-4000 {
          animation-delay: 4000ms;
        }
      `}</style>

    </div>




  );
};

export default EngagementModel;